import { Link } from "react-router-dom";
import { trackNavigation } from "../../utils/analytics";
import "./footer.css";

export default function Footer() {
  return (
    <footer id="footer">
      <div id="legal">
        <p>
          &copy; 2026 Grand Hôtel - Location Cure Thermale. Tous droits
          réservés.
        </p>
        <Link
          to="/legal"
          onClick={() => trackNavigation("/legal", "Mentions légales")}
        >
          Mentions légales
        </Link>
      </div>
    </footer>
  );
}
